import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import axiosInstance from "../../API/Axios/AxiosConfig";
import URLS from "../../API/Axios/URLS";
import {toast} from "react-toastify";

const initialState = {
    count:0,
    next:null,
    previous:null,
    results:[],
}

export const QUESTION_ACTIONS = {
    GET_QUESTIONS: "GET_QUESTIONS",
}


const QuestionListReducer = (state = initialState, action) => {
    switch (action.type) {
        case QUESTION_ACTIONS.GET_QUESTIONS:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}


export function useQuestionList() {
    const dispatch = useDispatch();
    const state = useSelector(state => state.QuestionListReducer);
    const [isLoading, setIsLoading] = useState(false);




    const loadQuestions = (cat) => {
        setIsLoading(true)
        return new Promise((resolve, reject) => {
            toast.promise(axiosInstance.get(URLS.listQuestions+cat ), {
                pending: "Loading...",
                error: "Something went wrong",
            },{
                hideProgressBar:false,
                toastId:"load-all-questions"
            }).then( (res) => {
                setIsLoading(false)
                dispatch({
                    type: QUESTION_ACTIONS.GET_QUESTIONS,
                    payload: res.data,
                })

            }).catch((err) => {
                reject(err);
                setIsLoading(false)
            })
        })
    };
    const loadFilteredQuestions = (cat,filter) => {
        setIsLoading(true)
        return new Promise((resolve, reject) => {
            toast.promise(axiosInstance.get(URLS.listQuestions+cat+"?"+filter), {
                pending: "Loading...",
                error: "Something went wrong",
            },{
                hideProgressBar:false,
                toastId:"load-all-questions"
            }).then( (res) => {
                setIsLoading(false)
                dispatch({
                    type: QUESTION_ACTIONS.GET_QUESTIONS,
                    payload: res.data,
                })

            }).catch((err) => {
                reject(err);
                setIsLoading(false)
            })
        })

    }
    const loadNextPage = () => {
        return new Promise((resolve, reject) => {
            toast.promise(axiosInstance.get(state?.next), {
                pending: "Loading...",
                success:"Questions Loaded",
                error: "Something went wrong",
            },{
                hideProgressBar:false,
                toastId:"load-all-questions"
            }).then( (res) => {
                dispatch({
                    type: QUESTION_ACTIONS.GET_QUESTIONS,
                    payload: {
                        count:res.data?.count,
                        next:res.data?.next,
                        previous:res.data?.previous,
                        results:[...state.results,...res.data?.results],
                    },
                })

            }).catch((err) => {
                reject(err);
            })
        })
    };

    const actions = {
       loadQuestions:loadQuestions,
        loadNextPage:loadNextPage,
        loadFilteredQuestions:loadFilteredQuestions,


    }



    return {
        questionList: state,
        questionActions: actions,
        isLoading: isLoading,

    }
}


export default QuestionListReducer;
